import Blue from "~/core"

new Blue({
  name: 'Flyout Nav Menu',
  selector: ".header__menu",
  setup(flyout) {
    const navToggles = flyout.querySelectorAll('.js-nav-control-toggle'),
    navTogglesInner = flyout.querySelectorAll('.js-nav-control-inner'),
    navTogglesBack = flyout.querySelectorAll('.js-nav-control-back'),
    navToggleMobile = document.getElementById('js-mobile-nav-toggle')
    //navTogglesTertiary = flyout.querySelectorAll('js-nav-control--tertiary'),
    //navWrappers = flyout.querySelectorAll('js-nav-wrapper'),

    // Toggle hamburger nav on mobile
    this.$addEvents(navToggleMobile, 'click', function() {
        const siblingNav = navToggleMobile.nextElementSibling        
        if(!(siblingNav.className === 'is-open')) {
            createScrim()
        }
        navAttributes(siblingNav)
        this.toggleAttribute('aria-expanded')
    })

    // Toggle main nav subnavs
    navToggles.forEach(e => {
        this.$addEvents(e, 'click', function() {
            const siblingNav = e.nextElementSibling,
            firstFocusEl = siblingNav.querySelector('.nav__logo')
            if(!(siblingNav.className === 'is-open')) {
                createScrim()
            }
            navAttributes(siblingNav)  
            e.toggleAttribute('aria-expanded')
            // basic focus trap
            siblingNav.addEventListener('focusout', () => {
                if (!siblingNav.matches(':focus-within')) {
                    firstFocusEl.focus()
                }
            })
        })
        
    })

    // Handles closing and opening via the x button inside a nav
    navTogglesInner.forEach(e => {
        this.$addEvents(e, 'click', function() {
            let parentNav = e.parentElement
            // checking that its not the mobile hamburger menu
            if (e.closest('.nav__wrapper') !== null) {
                parentNav = e.closest('.nav__wrapper');
            } else {
                parentNav = e.closest('.header__menu');
            }

            if (e.dataset.target) {
                parentNav = e.closest(e.dataset.target);
            }

            navInnerAttributes (parentNav);

            // checking if the closing menu is the last menu or its the mobile menu
            if((window.matchMedia('(min-width: 991px)').matches && parentNav.closest('.nav').classList.contains('nav--primary')) || parentNav.classList.contains('header__menu'))
                destroyScrim()            
        })
    })
    // when inside a flyout, this will let you go to the previous nav using the previous
    navTogglesBack.forEach(e => {
        this.$addEvents(e, 'click', function() {
            $(e).closest('.nav__wrapper.is-open').find('> .nav__branding .js-nav-control-inner').click()
        })
    })

    // Some reusable attribute toggles. You could combine them with some conditional logic passed to the function ie. navAttributes(element, timeout, prevBtn) but splitting them felt reasonable
    function navInnerAttributes (element) {
        element.classList.toggle('is-open')
        element.toggleAttribute('aria-expanded')
        element.previousElementSibling.toggleAttribute('aria-expanded')
        setTimeout(() => {
            // delay set to compliment animation time 
            element.toggleAttribute('aria-hidden')
        }, 500)
    }
    function navAttributes (element) {
        element.classList.toggle('is-open')
        element.toggleAttribute('aria-expanded')
        element.toggleAttribute('aria-hidden') 
    }
    // creates and destroys modal background element. note that on inner navs the scrim is faked with an after element
    function createScrim () {
        let scrimTest = document.getElementById('js-scrim')
        if(!scrimTest) {
            let scrim = document.createElement('div')
            scrim.id = 'js-scrim'
            scrim.classList.add('nav__scrim', 'is-open')
            document.body.appendChild(scrim)
            document.body.classList.add('scrim-is-open')
            listenScrim()
        }
      }
    function destroyScrim () {
        let scrim = document.getElementById('js-scrim')
        if(scrim){
            scrim.parentNode.removeChild(scrim)
            document.body.classList.remove('scrim-is-open')
        }
    }
    function listenScrim () {
        let scrim = document.getElementById('js-scrim')
        if(scrim){
            scrim.addEventListener('click', function () { 
                const openNavs = document.querySelectorAll('.nav__wrapper.is-open')
                const openMenu = document.querySelector('.header__menu.is-open')
                // toggle main nav
                if(openMenu) { 
                    navAttributes(openMenu)
                }
                
                // toggle subnavs if they exist
                if(openNavs.length > 0) {
                    openNavs.forEach(e => {
                        navAttributes(e)
                    })
                }
                destroyScrim()
            })
        }
      }
  }
})